import { render, staticRenderFns } from "./registrazionePagamenti.vue?vue&type=template&id=10fdee11&"
import script from "./registrazionePagamenti.vue.ts?vue&type=script&lang=ts&"
export * from "./registrazionePagamenti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports